<template>
  <div
    class="modal fade"
    id="surveyUploadDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <!-- Close button in the upper right corner -->
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="closeSurveyUploadDialog()"
          >
            ×
          </button>
          <!-- Modal Title -->
          <h4 class="modal-title">
            <b>{{ lang.SU0000 }}</b>
            <br />
          </h4>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="col-md-4">
                <div class="file-controls">
                  <label
                    class="btn btn-fab btn-fab-mini"
                    id="fileChooserButton"
                    :disabled="disableAddFileButton"
                  >
                    <i class="material-icons">note_add</i>
                    <input
                      type="file"
                      @change="handleFiles"
                      id="fileChooser"
                      :accept="questionData.acceptedTypes"
                      :multiple="questionData.allowMultipleFiles"
                      :disabled="disableAddFileButton"
                    />
                    <b-tooltip
                      ref="tooltip"
                      target="fileChooserButton"
                      triggers="hover"
                      v-if="
                        questionData.allowMultipleFiles ||
                        selectedFiles.length < 1
                      "
                      :delay="globals.tooltipDelay"
                      >{{ lang.SU0009 }}</b-tooltip
                    >
                  </label>
                  <button
                    type="button"
                    class="btn btn-fab btn-fab-mini"
                    :disabled="countFilesToDelete === 0"
                    @click="onDeleteFiles()"
                    id="deleteFilesButton"
                  >
                    <i class="material-icons">delete</i>
                    <b-tooltip
                      ref="tooltip"
                      target="deleteFilesButton"
                      triggers="hover"
                      v-if="countFilesToDelete !== 0"
                      :delay="globals.tooltipDelay"
                      >{{ lang.SU0010 }}</b-tooltip
                    >
                  </button>
                </div>
              </div>
              <div class="col-md-8">
                <div
                  class="file-controls"
                  v-show="showFiles && editimg && canvas.showCanvas"
                >
                  <div class="col-md-1">
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini btn-save-mini"
                      @click="saveImage()"
                      id="saveImageButton"
                    >
                      <i class="material-icons">save</i>
                      <b-tooltip
                        ref="tooltip"
                        target="saveImageButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0011 }}</b-tooltip
                      >
                    </button>
                  </div>
                  <div class="col-md-5">
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini btn-mode-select"
                      :disabled="currentMode === 'crop'"
                      @click="setCurrentMode('crop')"
                      id="scalingModeButton"
                    >
                      <i class="material-icons">transform</i>
                      <b-tooltip
                        ref="tooltip"
                        target="scalingModeButton"
                        triggers="hover"
                        v-if="currentMode !== 'crop'"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0012 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini btn-mode-select"
                      :class="{
                        'btn-mode-selected':
                          dragMode === 'move' && currentMode === 'crop',
                      }"
                      :disabled="currentMode === 'colorize'"
                      @click="onSetDragMode('move')"
                      id="dragModeButton"
                    >
                      <i class="material-icons">open_with</i>
                      <b-tooltip
                        ref="tooltip"
                        target="dragModeButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0016 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'colorize'"
                      @click="onZoomIn()"
                      id="zoomInButton"
                    >
                      <i class="material-icons">zoom_in</i>
                      <b-tooltip
                        ref="tooltip"
                        target="zoomInButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0013 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'colorize'"
                      @click="onZoomOut()"
                      id="zoomOutButton"
                    >
                      <i class="material-icons">zoom_out</i>
                      <b-tooltip
                        ref="tooltip"
                        target="zoomOutButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0014 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'colorize'"
                      @click="onZoomToOriginalSize()"
                      id="zoomToOriginalSizeButton"
                    >
                      <i class="material-icons">zoom_out_map</i>
                      <b-tooltip
                        ref="tooltip"
                        target="zoomToOriginalSizeButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0015 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'colorize'"
                      @click="onRotateLeft()"
                      id="rotateLeftButton"
                    >
                      <i class="material-icons">rotate_left</i>
                      <b-tooltip
                        ref="tooltip"
                        target="rotateLeftButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0017 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'colorize'"
                      @click="onRotateRight()"
                      id="rotateRightButton"
                    >
                      <i class="material-icons">rotate_right</i>
                      <b-tooltip
                        ref="tooltip"
                        target="rotateRightButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0018 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini btn-mode-select"
                      :class="{
                        'btn-mode-selected':
                          dragMode === 'crop' && currentMode === 'crop',
                      }"
                      :disabled="currentMode === 'colorize'"
                      @click="onSetDragMode('crop')"
                      id="croppingModeButton"
                    >
                      <i class="material-icons">crop</i>
                      <b-tooltip
                        ref="tooltip"
                        target="croppingModeButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0019 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'colorize'"
                      @click="onCropImage()"
                      id="cropImageButton"
                    >
                      <i class="material-icons">crop_free</i>
                      <b-tooltip
                        ref="tooltip"
                        target="cropImageButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0020 }}</b-tooltip
                      >
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini btn-mode-select"
                      :disabled="currentMode === 'colorize'"
                      @click="
                        setCurrentMode('colorize'), setCurrentShape('line')
                      "
                      id="drawingModeButton"
                    >
                      <i class="material-icons">brush</i>
                      <b-tooltip
                        ref="tooltip"
                        target="drawingModeButton"
                        triggers="hover"
                        v-if="currentMode !== 'colorize'"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0021 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'crop'"
                      @click="setCurrentShape('line')"
                      id="penButton"
                    >
                      <i class="material-icons">edit</i>
                      <b-tooltip
                        ref="tooltip"
                        target="penButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0022 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'crop'"
                      @click="setCurrentShape('rectangle')"
                      id="rectangleButton"
                    >
                      <i class="material-icons">crop_16_9</i>
                      <b-tooltip
                        ref="tooltip"
                        target="rectangleButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0023 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'crop'"
                      @click="setCurrentShape('fillrectangle')"
                      id="fillRectangleButton"
                    >
                      <i class="material-icons">stop</i>
                      <b-tooltip
                        ref="tooltip"
                        target="fillRectangleButton"
                        triggers="hover"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0024 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'crop' || lastActionUndo"
                      @click="undoLastAction()"
                      id="undoButton"
                    >
                      <i class="material-icons">undo</i>
                      <b-tooltip
                        ref="tooltip"
                        target="undoButton"
                        triggers="hover"
                        v-if="!lastActionUndo"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0025 }}</b-tooltip
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-fab btn-fab-mini"
                      :disabled="currentMode === 'crop' || lastActionRedo"
                      @click="redoLastAction()"
                      id="redoButton"
                    >
                      <i class="material-icons">redo</i>
                      <b-tooltip
                        ref="tooltip"
                        target="redoButton"
                        triggers="hover"
                        v-if="!lastActionRedo"
                        :delay="globals.tooltipDelay"
                        >{{ lang.SU0026 }}</b-tooltip
                      >
                    </button>
                    <div class="form-group">
                      <label for="inputColor" class="col-md-5 control-label">{{
                        lang.SU0003
                      }}</label>
                      <div class="col-md-7">
                        <input
                          type="color"
                          class="form-control"
                          id="inputColor"
                          v-model="canvas.fillStyle"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="linewidth" class="col-md-5 control-label">{{
                        lang.SU0004
                      }}</label>
                      <div class="col-md-7">
                        <select
                          id="linewidth"
                          class="form-control"
                          v-model="canvas.lineWidth"
                          :disabled="currentMode === 'crop'"
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default" v-show="showFiles">
            <div class="panel-body">
              <div class="col-md-4">
                <div class="image-previewmode-grid">
                  <div
                    v-for="(file, index) in selectedFiles"
                    :key="index"
                    class="image"
                    :class="{
                      'image--delete': file.delete,
                      'image--active': index === edit,
                    }"
                  >
                    <img class="image-mini-previewMode" :src="file.imageUrl" />
                    <div class="image__hover">
                      <div class="image__inner">
                        <a class="image__trash" @click="onToggleDelete(index)">
                          <i class="material-icons">delete</i>
                        </a>
                        <a @click="setIndex(index)" class="image__edit">
                          <i class="material-icons">edit</i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="image-properties" v-show="edit > -1">
                  <table class="table table-striped">
                    <tbody>
                      <tr>
                        <td style="width: 35%">{{ lang.SU0005 }}</td>
                        <td style="width: 65%">
                          {{ editimg && editimg.name ? editimg.name : "-" }}
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 35%">{{ lang.SU0006 }}</td>
                        <td style="width: 65%">
                          {{
                            editimg && editimg.size
                              ? formatBytes(editimg.size, 1)
                              : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 35%">{{ lang.SU0007 }}</td>
                        <td style="width: 65%">
                          {{
                            editimg && editimg.lastModified
                              ? formatDate(editimg.lastModified)
                              : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 35%">{{ lang.SU0008 }}</td>
                        <td style="width: 65%">
                          {{ editimg && editimg.type ? editimg.type : "-" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-8" v-show="edit > -1 && canvas.showCanvas">
                <div class="show-image">
                  <vue-cropper
                    v-show="currentMode === 'crop'"
                    ref="cropper"
                    :guides="true"
                    :view-mode="2"
                    drag-mode="move"
                    :auto-crop-area="0.5"
                    :min-container-width="250"
                    :min-container-height="180"
                    :background="true"
                    :rotatable="true"
                    :src="editimg ? editimg.imageUrl : ''"
                    alt="Source Image"
                    :img-style="{
                      width: imageSize.width + 'px',
                      height: imageSize.height + 'px',
                    }"
                  ></vue-cropper>
                  <canvas
                    id="editCanvas"
                    v-show="currentMode === 'colorize'"
                  ></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Add modal buttons here -->
          <button
            type="button"
            class="btn btn-raised btn-default"
            @click="closeSurveyUploadDialog()"
          >
            {{ lang.SU0002 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="saveFilesToBackend()"
            :disabled="
              !globals.isAccessAllowed('LoopOp_Upload_Create') ||
              !disableUploadButton
            "
          >
            {{ lang.SU0001 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";

export default {
  name: "SurveyUploadDialog",
  props: ["showDialog", "questionData"],
  components: {
    "vue-cropper": VueCropper,
  },
  created() {
    this.globals.$off("SurveyUploadDialogYesConfirmation");
    this.globals.$on("SurveyUploadDialogYesConfirmation", () => {
      this.setImageEdited(false);
      this.filesAdded = false;
      if (this.fileChanged) {
        this.setIndex(this.index);
        this.fileChanged = false;
      }

      if (this.currentModeChanged) {
        this.currentModeChanged = false;
        this.currentMode = this.currentMode === "crop" ? "colorize" : "crop";
      }

      this.closeDialog ? this.closeSurveyUploadDialog() : this.restoreImage();
    });
  },
  watch: {
    showDialog() {
      if (this.showDialog) this.openSurveyUploadDialog();
      else this.closeSurveyUploadDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    edit() {
      if (this.edit > -1) this.getImage();
    },
    currentMode() {
      if (this.currentMode === "colorize") this.setCanvasSize();
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#surveyUploadDialog").on("hidden.bs.modal", () =>
      this.$emit("dialogClosed")
    );
    this.getImage();
    this.initCanvas();
    $(window)
      .on("resize", () => {
        this.canvas.showCanvas = false;
        let timeoutFunc = () => {
          this.canvas.showCanvas = true;
          this.setCanvasSize();
        };
        if (this.windowResizeTimer) clearTimeout(this.windowResizeTimer);
        this.windowResizeTimer = setTimeout(timeoutFunc, 300);
      })
      .resize();
  },
  data() {
    return {
      selectedFiles: [],
      edit: -1,
      cropedImage: null,
      showFiles: false,
      currentMode: "crop",
      dragMode: "drag",
      windowResizeTimer: null,
      imageSize: {
        height: 0,
        width: 0,
      },
      canvas: {
        editCanvas: null,
        editCanvasContext: null,
        editImage: null,
        prevX: 0,
        prevY: 0,
        currX: 0,
        currY: 0,
        lineWidth: 2,
        fillStyle: "#000000",
        globalCompositeOperation: "source-over",
        mouseClicked: false,
        scaleOnNextDraw: 1,
        height: 0,
        width: 0,
        currentShape: "line",
        showCanvas: true,
      },
      lang: {
        SU0000: "Edit Uploads",
        SU0001: "Upload",
        SU0002: "Close",
        SU0003: "Color",
        SU0004: "Line width",
        SU0005: "Name",
        SU0006: "Size",
        SU0007: "Last modified",
        SU0008: "File type",
        SU0009: "Add files",
        SU0010: "Delete selected files",
        SU0011: "Save changes",
        SU0012: "Scaling mode",
        SU0013: "Zoom in",
        SU0014: "Zoom out",
        SU0015: "Zoom to original size",
        SU0016: "Drag mode",
        SU0017: "Rotate left",
        SU0018: "Rotate right",
        SU0019: "Cropping mode",
        SU0020: "Crop image",
        SU0021: "Drawing mode",
        SU0022: "Pen",
        SU0023: "Frame",
        SU0024: "Rectangle",
        SU0025: "Undo",
        SU0026: "Redo",
        SU0027: "Discard changes",
        SU0028: "Yes",
        SU0029: "No",
        SU0030: "There are unsaved changes. Do you want to proceed?",
      },
      shapes: [],
      shape: {},
      editedImages: [],
      editedImage: {},
      indexToDelete: [],
      countFilesToDelete: 0,
      filesToDeleteInSurvey: [],
      editimg: null,
      fileTypesMimeIcons: {
        ods: "/static/mime/ods.png", // open/libre office calc
        odt: "/static/mime/odt.png", // open/libre office writer
        doc: "/static/mime/doc.png", // ms office word
        docx: "/static/mime/doc.png", // ms office word
        xls: "/static/mime/xls.png", // ms office excel
        xlsx: "/static/mime/xlsx.png", // ms office excel
        pdf: "/static/mime/pdf.png", // pdf
        txt: "/static/mime/txt.png", // text file
        zip: "/static/mime/zip.png", // zip file
        default: "/static/mime/blank.png", // all other files
      },
      imageTypes: ["jpg", "jpeg", "gif", "png", "tif"],
      imageEdited: false,
      imageSaved: false,
      disableUploadButton: false,
      currentShapesLength: -1,
      lastActionRedo: true,
      lastActionUndo: true,
      disableAddFileButton: false,
      filesAdded: false,
      closeDialog: false,
      currentModeChanged: false,
      currentShapesLengthSaved: 0,
      fileChanged: false,
      index: -1,
    };
  },
  methods: {
    getConfirmationDialogData() {
      return {
        initiator: "SurveyUploadDialog",
        confirmationTitle: this.lang.SU0027,
        yesButtonText: this.lang.SU0028,
        noButtonText: this.lang.SU0029,
        colorRed: true,
        htmlText: `<b>${this.lang.SU0030}</b>`,
      };
    },
    restoreImage() {
      // if (this.fileChanged) {
      //   this.cropedImage = null;
      //   this.shape = {};
      //   this.shapes = [];
      //   this.fileChanged = false;
      // } else {
      this.cropedImage = null;
      if (this.currentMode === "crop") {
        this.getImage();
      } else {
        this.shape = {};
        this.shapes.splice(this.currentShapesLengthSaved, this.shapes.length);
        this.currentShapesLength = this.currentShapesLengthSaved;
        this.draw(this.currentShapesLengthSaved);
      }
      // }
    },
    saveFilesToBackend() {
      let filesToUpload = {};
      this.filesAdded = false;
      if (!this.imageEdited) {
        filesToUpload = {
          questionName: this.questionData.questionName,
          files: this.selectedFiles.filter((file) => {
            return !file.content;
          }),
          filesToDeleteInSurvey: this.filesToDeleteInSurvey,
        };
        this.$emit("dialogDataSaved", filesToUpload);
        this.globals.$on("surveyAttachmentUploadComplete", () => {
          this.filesAdded = false;
          this.fileChanged = false;
          this.closeSurveyUploadDialog();
        });
        if (filesToUpload.files.length < 1) this.closeSurveyUploadDialog();
      } else {
        this.closeDialog = true;
        this.globals.$emit(
          "openGlobalConfirmationDialog",
          this.getConfirmationDialogData()
        );
      }
    },
    openSurveyUploadDialog() {
      $("#surveyUploadDialog").modal("show");
      this.initQuestionContent();
    },
    closeSurveyUploadDialog() {
      if (!this.imageEdited && !this.filesAdded && !this.fileChanged) {
        this.edit = -1;
        this.editimg = null;
        this.selectedFiles = [];
        this.cropedImage = null;
        this.showFiles = false;
        this.currentMode = "crop";
        this.shapes = [];
        this.shape = {};
        this.editedImages = [];
        this.editedImage = {};
        this.countFilesToDelete = 0;
        this.canvas.lineWidth = 2;
        this.canvas.fillStyle = "#000000";
        this.canvas.currentShape = "line";
        this.filesToDeleteInSurvey = [];
        this.disableUploadButton = false;
        this.lastActionRedo = true;
        this.lastActionUndo = true;
        $("#fileChooser").val("");
        $("#surveyUploadDialog").modal("hide");
      } else {
        this.closeDialog = true;
        this.globals.$emit(
          "openGlobalConfirmationDialog",
          this.getConfirmationDialogData()
        );
      }
    },
    initCanvas() {
      this.imageSize.height = $(".show-image").height();
      this.imageSize.width = $(".show-image").width();
      // initialize canvas
      this.canvas.editCanvas = document.getElementById("editCanvas");
      this.canvas.editCanvasContext = this.canvas.editCanvas.getContext("2d");
      // mouse listener
      this.canvas.editCanvas.addEventListener(
        "mousemove",
        this.handleMouseEvent
      );
      this.canvas.editCanvas.addEventListener(
        "mousedown",
        this.handleMouseEvent
      );
      this.canvas.editCanvas.addEventListener("mouseup", this.handleMouseEvent);
      this.canvas.editCanvas.addEventListener(
        "mouseout",
        this.handleMouseEvent
      );
    },
    initQuestionContent() {
      if (
        this.questionData.questionContent &&
        this.questionData.questionContent.length > 0
      ) {
        this.selectedFiles = this.questionData.questionContent;
        _.forEach(this.selectedFiles, (file) => {
          this.setMimeTypeIcon(file);
          file.delete = false;
        });
        this.showFiles = true;
      }
      this.disableAddFileButton =
        !this.questionData.allowMultipleFiles &&
        this.selectedFiles.length === 1;
    },
    handleFiles(event) {
      let oldSelectedFiles = [];
      if (event.target.files.length < 1) return; // File selection aborted
      if (this.selectedFiles) {
        // no duplicate files
        oldSelectedFiles = this.selectedFiles;
        this.selectedFiles = _.unionBy(
          oldSelectedFiles,
          Array.from(event.target.files),
          "name"
        );
        this.disableUploadButton =
          oldSelectedFiles.length !== this.selectedFiles.length;
      } else {
        this.selectedFiles = Array.from(event.target.files);
        this.disableUploadButton = true;
      }
      event.target.value = null;

      let callback = () => {
        this.showFiles = true;
        this.updateFileList();
        this.$forceUpdate();
        this.filesAdded = !this.filesAdded
          ? oldSelectedFiles.length !== this.selectedFiles.length
          : this.filesAdded;
        this.disableAddFileButton =
          !this.questionData.allowMultipleFiles &&
          this.selectedFiles.length === 1;
      };
      for (let i = 0; i < this.selectedFiles.length; i++) {
        if (!this.selectedFiles[i].content) {
          if (_.startsWith(this.selectedFiles[i].type, "image")) {
            this.selectedFiles[i].imageUrl = URL.createObjectURL(
              this.selectedFiles[i]
            );
            this.globals.getImageOrientation(
              this.selectedFiles[i],
              (orientation) => {
                this.globals.resetImageOrientation(
                  this.selectedFiles[i],
                  orientation,
                  (data) => {
                    this.selectedFiles[i] = data;
                    this.selectedFiles[i].delete = false;
                    this.setMimeTypeIcon(this.selectedFiles[i]);
                    if (i === this.selectedFiles.length - 1) callback();
                    this.$forceUpdate();
                  }
                );
              }
            );
          } else {
            this.selectedFiles[i].delete = false;
            this.setMimeTypeIcon(this.selectedFiles[i]);
            callback();
          }
        }
      }
    },
    setMimeTypeIcon(file) {
      let words = file.name.split(".");
      let extension = words[words.length - 1];
      if (this.imageTypes.indexOf(extension.toLowerCase()) > -1) {
        file.imageUrl = file.content
          ? "/api/Download/" + file.content
          : URL.createObjectURL(file);
      } else
        file.imageUrl =
          this.fileTypesMimeIcons[extension] ||
          this.fileTypesMimeIcons["default"];
    },
    onToggleDelete(index) {
      this.selectedFiles[index].delete = !this.selectedFiles[index].delete;
      this.countFilesToDelete = Object.keys(this.selectedFiles).reduce(
        (count, key) => {
          if (this.selectedFiles[key].delete) count++;
          return count;
        },
        0
      );
      if (this.editedImages.length > 0) {
        _.forEach(this.editedImages, (image) => {
          if (image.index === index) {
            image.delete = !image.delete;
          }
        });
      }
      this.$forceUpdate();
    },
    onDeleteFiles() {
      this.selectedFiles = this.selectedFiles.filter((file) => {
        if (file.delete) this.filesToDeleteInSurvey.push({ name: file.name });
        return !file.delete;
      });

      if (this.editedImages.length > 0) {
        let filesToDelete = _.filter(this.editedImages, (image) => {
          return image.delete;
        });
        let nrFilesToDelete = _.size(filesToDelete);
        let maxIndex = filesToDelete.reduce(
          (max, item) => (item.index > max ? item.index : max),
          0
        );
        this.editedImages.map((file) => {
          file.index =
            file.index > maxIndex ? file.index - nrFilesToDelete : file.index;
        });
        this.editedImages = _.remove(this.editedImages, (image) => {
          return !image.delete;
        });
      }
      this.showFiles = this.selectedFiles.length > 0 ? true : false;
      this.edit = -1;
      this.editimg = null;
      this.cropedImage = null;
      this.currentMode = "colorize";
      this.countFilesToDelete = 0;
      this.disableUploadButton = true;
      this.filesAdded = true;
      this.disableAddFileButton =
        !this.questionData.allowMultipleFiles &&
        this.selectedFiles.length === 1;
    },
    setImageEdited(edit) {
      this.imageEdited = edit;
      if (!edit) {
        this.lastActionRedo = true;
        this.lastActionUndo = true;
      }
      this.imageEdited
        ? ($(".btn-save-mini").css("background-color", "red"),
          (this.disableUploadButton = false))
        : ($(".btn-save-mini").css("background-color", "green"),
          (this.disableUploadButton = true));
    },
    onCropImage() {
      let imageType = this.selectedFiles[this.index].type;
      this.cropedImage = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL(imageType);
      this.$refs.cropper.replace(this.cropedImage);
      this.setImageEdited(true);
    },
    onZoomIn() {
      this.$refs.cropper.relativeZoom(0.1);
    },
    onZoomOut() {
      this.$refs.cropper.relativeZoom(-0.1);
    },
    onRotateLeft() {
      this.$refs.cropper.rotate(-90);
      this.getRotatedImage();
      this.setImageEdited(true);
    },
    onRotateRight() {
      this.$refs.cropper.rotate(90);
      this.getRotatedImage();
      this.setImageEdited(true);
    },
    onZoomToOriginalSize() {
      this.$refs.cropper.zoomTo(1);
    },
    onSetDragMode(dragMode) {
      this.$refs.cropper.setDragMode(dragMode);
      this.dragMode = dragMode;
    },
    getRotatedImage() {
      // change to old way if browser doesn't support object destructuring
      let {
        width: canvasWidth,
        height: canvasHeight,
      } = this.$refs.cropper.getCanvasData();
      let {
        left: cropBoxLeft,
        top: cropBoxTop,
        width: cropBoxWidth,
        height: cropBoxHeight,
      } = this.$refs.cropper.getCropBoxData();
      this.$refs.cropper.setCropBoxData({
        left: 0,
        top: 0,
        width: canvasWidth,
        height: canvasHeight,
      });

      let imageType = this.selectedFiles[this.index].type;
      this.cropedImage = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL(imageType);
      this.$refs.cropper.setCropBoxData({
        left: cropBoxLeft,
        top: cropBoxTop,
        width: cropBoxWidth,
        height: cropBoxHeight,
      });
    },
    updateFileList() {
      if (this.editedImages.length > 0) {
        this.editedImages.forEach((image) => {
          this.selectedFiles[image.index] = image.image;
          this.selectedFiles[image.index].imageUrl = URL.createObjectURL(
            image.image
          );
          this.selectedFiles[image.index].delete = false;
          this.selectedFiles[image.index].index = image.index;
        });
      }
    },
    saveImage() {
      // check if a selected image was already edited
      let idx = _.findIndex(
        this.editedImages,
        (image) => image.index === this.edit
      );
      let imageType = this.selectedFiles[this.index].type;

      // Convert Blob to File
      // source: https://stackoverflow.com/questions/27159179/how-to-convert-blob-to-file-in-javascript
      let file = null;
      if (this.currentMode === "crop" && this.cropedImage) {
        file = this.globals.dataURItoBlob(this.cropedImage);
      } else if (this.currentMode === "colorize") {
        file = this.globals.dataURItoBlob(
          this.canvas.editCanvas.toDataURL(imageType)
        );
      }

      file.name = this.editimg.name;
      file.lastModifiedDate = new Date();
      if (idx > -1) {
        this.editedImages[idx].image = file;
      } else {
        this.editedImage = {
          index: this.edit,
          image: file,
        };
      }
      this.currentShapesLengthSaved = this.shapes.length;
      this.cropedImage = null;

      if (!_.isEmpty(this.editedImage))
        this.editedImages.push(this.editedImage);
      let newEditimg =
        idx > -1 ? this.editedImages[idx].image : this.editedImage.image;
      if (newEditimg) this.editimg = newEditimg;
      this.updateFileList();
      this.$forceUpdate();
      this.editedImage = {};
      this.setImageEdited(false);
      this.imageSaved = true;
      this.fileChanged = true;
    },
    drawImageOnCanvas(image) {
      this.canvas.editCanvasContext.setTransform(1, 0, 0, 1, 0, 0);
      if (!this.canvas.editImage) {
        this.canvas.editImage = new Image();
        this.canvas.editImage.src = image.imageUrl;
      }
      if (this.cropedImage) this.canvas.editImage.src = this.cropedImage;
      this.canvas.editCanvas.height = this.canvas.editImage.height;
      this.canvas.editCanvas.width = this.canvas.editImage.width;
      this.canvas.scaleOnNextDraw =
        this.canvas.editImage.height / this.canvas.height;
      this.canvas.editCanvasContext.drawImage(this.canvas.editImage, 0, 0);
    },
    clearCanvas() {
      // clear canvas
      // Use the identity matrix while clearing the canvas
      this.canvas.editCanvasContext.setTransform(1, 0, 0, 1, 0, 0);
      this.canvas.editCanvasContext.clearRect(
        0,
        0,
        this.canvas.editCanvas.width,
        this.canvas.editCanvas.height
      );
    },
    formatDate(dateInMs) {
      return this.globals.getLocalizedDateTimeFromIsoTimestamp(dateInMs);
    },
    formatBytes(a, b) {
      // source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
      if (0 == a) return "0 Bytes";
      var c = 1024,
        d = b || 2,
        e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        f = Math.floor(Math.log(a) / Math.log(c));
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
    },
    undoLastAction() {
      this.currentShapesLength -= 1;
      this.lastActionUndo = this.currentShapesLength > 0 ? false : true;
      this.setImageEdited(!this.lastActionUndo);
      this.lastActionRedo = false;
      this.draw(this.currentShapesLength);
    },
    redoLastAction() {
      if (this.currentShapesLength < this.shapes.length) {
        this.currentShapesLength += 1;
        this.lastActionUndo = false;
      }
      this.lastActionRedo =
        this.currentShapesLength < this.shapes.length ? false : true;
      this.setImageEdited(true);
      this.draw(this.currentShapesLength);
    },
    handleMouseEvent(e) {
      if (e.type === "mousedown") {
        this.canvas.prevX = this.canvas.currX;
        this.canvas.prevY = this.canvas.currY;
        this.canvas.currX = e.offsetX;
        this.canvas.currY = e.offsetY;
        this.canvas.mouseClicked = true;
        this.shape.name = this.canvas.currentShape;
        this.shape.color = this.canvas.fillStyle;
        this.shape.lineWidth = this.canvas.lineWidth;
        if (this.canvas.currentShape !== "line") {
          this.shape.startX = this.canvas.currX;
          this.shape.startY = this.canvas.currY;
        }
        if (this.canvas.currentShape === "line") {
          this.shape.linePoints = [];
          let linePoint = {
            previousPoint: {
              x: this.canvas.currX,
              y: this.canvas.currY,
            },
            currentPoint: {
              x: this.canvas.currX,
              y: this.canvas.currY,
            },
          };
          this.shape.linePoints.push(linePoint);
        }
        this.draw(this.currentShapesLength);
      }
      if (e.type === "mouseup") {
        this.canvas.mouseClicked = false;
        if (this.currentShapesLength < this.shapes.length)
          this.shapes.splice(this.currentShapesLength, this.shapes.length);
        this.shapes.push(this.shape);
        this.shape = {};
        this.setImageEdited(true);
        this.currentShapesLength = this.shapes.length;
        this.lastActionUndo = false;
        this.lastActionRedo = true;
      }
      if (e.type === "mouseout") {
        this.canvas.mouseClicked = false;
      }
      if (e.type === "mousemove") {
        if (this.canvas.mouseClicked) {
          this.canvas.prevX = this.canvas.currX;
          this.canvas.prevY = this.canvas.currY;
          this.canvas.currX = e.offsetX;
          this.canvas.currY = e.offsetY;
          if (this.canvas.currentShape === "line") {
            let linePoint = {
              previousPoint: {
                x: this.canvas.prevX,
                y: this.canvas.prevY,
              },
              currentPoint: {
                x: this.canvas.currX,
                y: this.canvas.currY,
              },
            };
            this.shape.linePoints.push(linePoint);
          }
          if (this.canvas.currentShape !== "line") {
            this.shape.width = this.canvas.currX - this.shape.startX;
            this.shape.height = this.canvas.currY - this.shape.startY;
          }
          this.draw(this.currentShapesLength);
        }
      }
    },
    drawShape(shape) {
      this.canvas.editCanvasContext.beginPath();
      switch (shape.name) {
        case "line":
          this.canvas.editCanvasContext.lineWidth = shape.lineWidth;
          this.canvas.editCanvasContext.strokeStyle = shape.color;
          this.canvas.editCanvasContext.lineCap = "round";
          shape.linePoints.forEach((linePoint) => {
            this.drawLine(
              linePoint.previousPoint.x,
              linePoint.previousPoint.y,
              linePoint.currentPoint.x,
              linePoint.currentPoint.y
            );
          });
          break;
        case "rectangle":
          this.drawRectangle(
            shape.startX,
            shape.startY,
            shape.width,
            shape.height,
            shape.color,
            shape.lineWidth
          );
          break;
        case "fillrectangle":
          this.drawFillRectangle(
            shape.startX,
            shape.startY,
            shape.width,
            shape.height,
            shape.color,
            shape.lineWidth
          );
          break;
      }
      this.canvas.editCanvasContext.stroke();
      this.canvas.editCanvasContext.closePath();
    },
    draw(numberOfShapes) {
      this.clearCanvas();
      if (!this.canvas.editImage) return;
      this.drawImageOnCanvas(this.canvas.editImage);
      if (this.canvas.scaleOnNextDraw !== 1) {
        this.canvas.editCanvasContext.scale(
          this.canvas.scaleOnNextDraw,
          this.canvas.scaleOnNextDraw
        );
        this.canvas.scaleOnNextDraw = 1;
      }
      // draw all saved shapes
      if (this.shapes.length > 0) {
        for (let i = 0; i < numberOfShapes; i++) {
          this.drawShape(this.shapes[i]);
        }
      }
      // draw current shape
      if (this.shape) this.drawShape(this.shape);
    },
    drawLine(startX, startY, endX, endY) {
      this.canvas.editCanvasContext.moveTo(startX, startY);
      this.canvas.editCanvasContext.lineTo(endX, endY);
    },
    drawRectangle(startX, startY, width, height, color, lineWidth) {
      this.canvas.editCanvasContext.lineWidth = lineWidth;
      this.canvas.editCanvasContext.strokeStyle = color;
      this.canvas.editCanvasContext.rect(startX, startY, width, height);
    },
    drawFillRectangle(startX, startY, width, height, color, lineWidth) {
      this.canvas.editCanvasContext.lineWidth = lineWidth;
      this.canvas.editCanvasContext.fillStyle = color;
      this.canvas.editCanvasContext.fillRect(startX, startY, width, height);
    },
    setCurrentShape(shape) {
      this.canvas.currentShape = shape;
    },
    setCurrentMode(mode) {
      if (!this.imageEdited) {
        if (this.canvas.editImage) {
          this.canvas.editImage = null;
          this.shape = {};
          this.shapes = [];
        }
        this.currentMode = mode;
        if (!this.editimg) return;
        if (this.currentMode === "colorize") {
          this.drawImageOnCanvas(this.editimg);
          this.setImageEdited(false);
        } else this.$refs.cropper.replace(this.editimg.imageUrl);
      } else {
        this.closeDialog = false;
        this.currentModeChanged = true;
        this.globals.$emit(
          "openGlobalConfirmationDialog",
          this.getConfirmationDialogData()
        );
      }
    },
    setIndex(index) {
      this.index = index;
      if (!this.imageEdited) {
        this.currentMode = "crop";
        this.onSetDragMode("move");
        if (this.canvas.editImage) {
          this.canvas.editImage = null;
          this.shape = {};
          this.shapes = [];
          this.cropedImage = null;
        }
        this.edit = index;
        this.setImageEdited(false);
      } else {
        this.closeDialog = false;
        this.fileChanged = true;
        this.globals.$emit(
          "openGlobalConfirmationDialog",
          this.getConfirmationDialogData()
        );
      }
    },
    getImage() {
      this.editimg =
        this.edit in this.selectedFiles ? this.selectedFiles[this.edit] : null;
      this.setCanvasSize();
    },
    calculateImageRatio(image, callback) {
      let imageObj = new Image();
      imageObj.onload = function () {
        callback(this.width / this.height);
      };
      imageObj.src = image.imageUrl;
    },
    setCanvasSize() {
      if (!this.editimg) return;

      // if selected element is an image -> show on canvas
      if (_.startsWith(this.editimg.type, "image")) {
        this.calculateImageRatio(this.editimg, (ratio) => {
          this.imageSize.height = $(".show-image").height();
          this.imageSize.width = $(".show-image").width();
          let displayRatio = this.imageSize.width / this.imageSize.height;
          let canvasHeight,
            canvasWidth,
            canvasTopSpace = 0,
            canvasLeftSpace = 0;
          if (displayRatio < ratio) {
            canvasWidth = this.imageSize.width;
            canvasHeight = this.imageSize.width / ratio;
            canvasTopSpace = (this.imageSize.height - canvasHeight) / 2;
          } else {
            canvasWidth = this.imageSize.height * ratio;
            canvasHeight = this.imageSize.height;
            canvasLeftSpace = (this.imageSize.width - canvasWidth) / 2;
          }
          this.canvas.editCanvas.style.height = canvasHeight.toString() + "px";
          this.canvas.editCanvas.style.width = canvasWidth.toString() + "px";
          this.canvas.editCanvas.style.marginTop =
            canvasTopSpace.toString() + "px";
          this.canvas.editCanvas.style.marginLeft =
            canvasLeftSpace.toString() + "px";
          this.canvas.height = canvasHeight;
          this.canvas.width = canvasWidth;
          this.currentMode === "crop"
            ? this.$refs.cropper.replace(this.editimg.imageUrl)
            : this.drawImageOnCanvas(this.editimg);
        });
        this.canvas.showCanvas = true;
      } else this.canvas.showCanvas = false;
    },
  },
};
</script>

<style scoped>
#surveyUploadDialog > .modal-dialog {
  width: calc(100vw - 100px);
}
#surveyUploadDialog .modal-body {
  max-height: calc(100vh - 160px);
  padding: 12px;
}
#surveyUploadDialog .modal-content {
  background-color: #eeeeee;
}
#surveyUploadDialog .modal-title {
  text-align: center;
}
#fileChooser {
  display: none;
}
.media-object {
  width: 128px;
  height: 128px;
}
.file-controls {
  position: relative;
  margin: 0.5em;
  padding: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  display: inline-flex;
  flex-direction: row;
}
.file-controls .btn {
  margin-right: 5px;
  margin-bottom: 5px;
  left: 5px;
}
.file-controls .form-group {
  display: inline-block;
}
.file-controls .form-group .control-label {
  margin-top: 8px;
}
#linewidth {
  margin: 0;
}
#deleteFilesButton {
  margin-right: 10px;
}
.image-properties {
  position: relative;
  display: inline-block;
  margin: 0.5em;
  padding: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
}
.show-image {
  height: calc(100vh - 365px);
  width: calc(100vw - 755px);
  position: relative;
  display: block;
  margin: 0.5em;
  padding: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  background: gray;
}
a:hover {
  text-decoration: underline;
}
.image-previewmode-grid {
  min-height: 120px;
  height: calc(100vh - 545px);
  overflow: auto;
  position: relative;
  display: block;
  margin: 0.5em;
  padding: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
}
.image {
  position: relative;
  display: inline-block;
  margin: 0.5em;
  padding: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
}
.image-mini-previewMode {
  width: 120px;
  height: 120px;
}
.image--active {
  background-color: #3eb998;
}
.image--active .image__inner {
  background: rgba(62, 185, 152, 0.5);
}
.image--active .image__trash {
  background-color: #3eb998;
  color: white;
}
.image--delete {
  background-color: #e83561;
}
.image--delete .image__trash {
  background-color: #e83561;
  color: white;
  display: block;
}
.image__hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 5px;
}
.image__inner {
  position: relative;
  width: 100%;
  height: 100%;
}
.image:hover .image__inner {
  background: rgba(62, 185, 152, 0.5);
}
.image__trash {
  position: absolute;
  display: block;
  background: white;
  padding: 0.2em 0.5em;
  color: #aaa;
  z-index: 2;
  display: none;
}
.image:hover .image__trash {
  display: block;
  cursor: pointer;
}
.image__edit {
  position: absolute;
  display: block;
  height: 100%;
  width: 100%;
  line-height: 120px;
  text-align: center;
  color: white;
  font-size: 1.3em;
  cursor: pointer;
  display: none;
}
.image:hover .image__edit {
  display: block;
}
.image__edit:hover {
  color: white;
}
.edit {
  position: relative;
  margin: 1em;
  padding: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}
.btn-mode-select {
  background: lightgray;
}
.btn-mode-selected,
.btn-mode-selected:active,
.btn-mode-selected:focus {
  background: lightblue !important;
}
.btn-save-mini {
  color: white;
  background-color: green;
}
</style>



// WEBPACK FOOTER //
// SurveyUploadDialog.vue?5351d5ac